import { Logger, ConsoleTransport, HttpTransport } from "@/utils/logger";
import { isBrowser, isDeployed } from "@/utils/platform";
import { universalStorage } from "@/utils/universal-storage";

const consoleTransport = new ConsoleTransport();
const transports = [consoleTransport];

if (isDeployed()) {
  const DATADOG_TOKEN = "pubc82d5f923cebe917d1e3ae71df88267f";
  const DATADOG_URL = `https://http-intake.logs.datadoghq.com/api/v2/logs?dd-api-key=${DATADOG_TOKEN}&ddsource=nodejs&service=web-account`;
  const datadogTransport = new HttpTransport(DATADOG_URL);

  transports.push(datadogTransport);
}

const is_browser = isBrowser();
export const logger = new Logger(transports, () => {
  return {
    env: import.meta.env.MODE,
    is_browser,
    user_id: universalStorage.get("user_id"),
    mobile_or_desktop: universalStorage.get("mobile_or_desktop"),
    url: universalStorage.get("url"),
    lang: universalStorage.get("lang"),
    client_ip: universalStorage.get("client_ip"),
  };
});
